import { Box, Flex, Text } from '@chakra-ui/react'
import { formatAttendeesText } from '../MeetingCards/ExpandedMeeting'


const Attendees = ({meeting}) => {
  return (
    <Flex
      flexDirection='column'
      border='0.5px solid rgba(28, 28, 28, 0.1)'
      boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
      borderRadius='12px'
      bg='white'
      p={5}
      flex={1}
      position='relative'
    >

      <Flex alignItems='center'>
        <Text color='#EF8354' fontWeight='800' fontSize='12px'>
          WHO
        </Text>
      </Flex>

      <Flex mt={3} alignItems='center'>
        <Text color='brandTextBlack' fontWeight='600' lineHeight='22px' maxW='166px'>
          {formatAttendeesText(meeting.attendees)}
        </Text>
      </Flex>

      <Flex position='absolute' h='52px' w='50px' right='20px' bottom='20px'>
        <Box bg='blackAlpha.400' h={6} w={6} borderRadius='100%' />
        <Box bg='blackAlpha.400' h={6} w={6} borderRadius='100%' position='absolute' bottom={0} />
        <Box bg='blackAlpha.400' h={6} w={6} borderRadius='100%'position='absolute' bottom={3} right={0}/>
      </Flex>

    </Flex>
  )
}

export default Attendees